interface DocumentData {
  documentType: string;
  dueDate: string;
  lastUpdatedOn: string;
  status: string;
  uuid: string;
  formId: string;
  dueDateString: string;
  lastUpdatedOnString: string;
  type: string;
  formType: string;
  visits: string;
  isOldest?: boolean;
}

export const getOldestRequiredDocumentUuid = (episodeOfCareRequiredDocumentData: any) => {
  if (!episodeOfCareRequiredDocumentData) {
    return undefined;
  }
  const sortedDocuments = episodeOfCareRequiredDocumentData.sort(
    (a: DocumentData, b: DocumentData) => {
      if (new Date(a.dueDate).getTime() === new Date(b.dueDate).getTime()) {
        const formTypePriority: Record<string, number> = {
          discharge: 1,
          recertification: 2,
          'weekly progress note': 3,
        };

        const priorityA = formTypePriority[a.formType.toLowerCase()] || Number.MAX_SAFE_INTEGER;
        const priorityB = formTypePriority[b.formType.toLowerCase()] || Number.MAX_SAFE_INTEGER;

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        } else {
          return a.formType.localeCompare(b.formType);
        }
      }

      return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
    }
  );

  return sortedDocuments[0]?.uuid;
};
